export default "__VITE_ASSET__cb53df04__"